// extracted by mini-css-extract-plugin
module.exports = {"SimplePage":"SimplePage_SimplePage__1i4q8","SimplePageMain":"SimplePage_SimplePageMain__1RldV"};